export default "__VITE_ASSET__980c56bf__"